import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');

  const filteredArticles = articles.filter((a) =>
    a.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    a.excerpt.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleReadArticle = (id: string) => {
    navigate(`/article/${id}`);
  };

  const scrollToResults = () => {
    document.getElementById('article-results')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="articles" className="py-16 md:py-20 bg-white">
      <div className="w-full px-4 sm:px-6 lg:px-10">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">{t('articles.title')}</h2>
          <div className="max-w-md mx-auto mt-4 flex gap-2">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder={t('search.placeholder')}
              className="flex-1 px-4 py-2.5 rounded-lg border border-gray-200 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
            />
            <button
              onClick={scrollToResults}
              className="px-4 py-2.5 rounded-lg bg-emerald-600 text-white text-sm font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap"
            >
              {t('search.cta')}
            </button>
          </div>
        </div>

        <div id="article-results" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {filteredArticles.map((article) => (
            <article key={article.id} className="group bg-white rounded-xl border border-gray-100 overflow-hidden hover:shadow-md transition-shadow duration-300 flex flex-col">
              <div className="aspect-[3/2] overflow-hidden bg-gray-100">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 text-xs text-gray-500 mb-2">
                  <span>{article.date}</span>
                  <span className="w-1 h-1 rounded-full bg-gray-300"></span>
                  <span>{article.readTime}</span>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2 text-sm md:text-base leading-snug group-hover:text-emerald-700 transition-colors">{article.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed line-clamp-3 mb-4">{article.excerpt}</p>
                <button
                  onClick={() => handleReadArticle(article.id)}
                  className="mt-auto text-sm font-semibold text-emerald-600 hover:text-emerald-700 inline-flex items-center gap-1 transition-colors"
                >
                  Read Guide
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}